import i18next from "i18next";
import { z } from "zod";

export function createAppRoleFormSchema(options?: { isNameDisabled?: boolean }) {
  const nameSchema = options?.isNameDisabled
    ? z.string()
    : z
        .string()
        .min(2, {
          message: i18next.t("ram:EnterAtLeastTwoCharacters"),
        })
        .refine((value) => !value.includes(" "), { message: i18next.t("ram:SpacesAreNotAllowed") });

  return z.object({
    name: nameSchema,
  });
}

export const appRoleFormSchema = createAppRoleFormSchema();

export type AppRoleFormSchemaType = z.infer<typeof appRoleFormSchema>;

export function isAppRoleSaveDisabled({
  isValid,
  isDirty,
  hasGroupChanges,
}: {
  isValid: boolean;
  isDirty: boolean;
  hasGroupChanges: boolean;
}): boolean {
  return !isValid || (!isDirty && !hasGroupChanges);
}
